<template>
  <b-container>
    <b-row style="padding-top: 24px">
      <b-col md="4">
        <div>
          <b-form-group>
            <div style="font-weight: bold; margin-bottom: 4px">City Code</div>
            <b-form-input placeholder="City Code" v-model="searchParams.cityCode" />
          </b-form-group>

          <b-form-group style="padding-top: 16px">
            <div style="font-weight: bold">Amadeus IDs</div>
            <div style="margin-bottom: 0px; font-size: 15px">(HOSTOGSK,OISTOHGF,...)</div>
            <div style="margin-bottom: 4px; font-size: 14px; color: gray">
              Must be comma separated 8 letter ids, no spaces.
            </div>

            <b-form-textarea
              placeholder="Hotel IDs"
              v-model="searchParams.hotelIds"
              style="height: 200px"
              @keydown.enter.native="handleSearch"
            />

          </b-form-group>

          <div style="margin-top: 12px; display: flex">
            <b-button variant="primary" style="flex: 1" @click="handleSearch">
              Search
            </b-button>
          </div>
        </div>
      </b-col>

      <b-col>
        <div v-if="isLoading" class="text-center">
          <b-spinner />
        </div>

        <div v-if="this.errorMessage">
          <h3 style="color: red">{{ this.errorMessage }}</h3>
        </div>

        <div v-if="this.hotels && this.hotels.length == 0 && !isLoading">
          No results found
        </div>

        <div v-if="this.hotels && this.hotels.length > 0">
          <h3>Search Results</h3>

          <b-button
            variant="success"
            style="flex: 1; font-size: 14px; font-weight: bold"
            @click="handleAddAll()"
          >
            Add All to Database
          </b-button>

          <div
            v-for="d in this.hotels"
            :key="d.hotel.hotelId"
            style="margin-bottom: 16px"
          >
            <hr />
            <div style="font-weight: bold">
              {{ d.hotel.name }}
            </div>

            <div style="font-size: 14px">
              {{ d.hotel.hotelId }}
            </div>

            <div style="font-size: 14px">
              <div v-for="line in d.hotel.address.lines" :key="line">
                {{ line }}
              </div>
              {{ `${d.hotel.address.cityName}, ${d.hotel.address.countryCode}` }}
            </div>

            <b-button
              variant="success"
              style="flex: 1; font-size: 14px; font-weight: bold"
              @click="handleAdd(d.hotel)"
            >
              Add to db
            </b-button>

            <div>
              <img
                :src="
                  d.hotel.media && d.hotel.media.length > 0 ? d.hotel.media[0].uri : ''
                "
                style="max-height: 300px; max-width: 100%; margin: 4px 0px 0px 0px"
              />
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      allHotels: [],
      hotels: null,
      searchParams: {},
      searchText: "",
      isLoading: false,
      selectedHotelImage: [],
      errorMessage: null,
    };
  },
  methods: {
    async handleAdd(hotel) {
      console.log(hotel);
      this.isLoading = true;
      try {
        const response = await fetch("/hotel/add", {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(hotel),
        });

        this.$bvToast.toast(`${hotel.name} added to database.`, {
          title: `Hotel Added`,
          autoHideDelay: 5000,
          variant: "success",
          solid: true,
        });
      } catch (e) {
        console.error(e);
      }

      this.isLoading = false;
    },
    async handleAddAll() {
      const response = await fetch(`/hotels/add_hotels`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(this.searchParams),
      });
      this.$bvToast.toast(`You can now search for these hotels in the Hotels DB section.`, {
          title: `Hotel Added Successfully`,
          autoHideDelay: 5000,
          variant: "success",
          solid: true,
        });
    },
    async handleSearch() {
      const validationMessage = this.validate();
      if (validationMessage) {
        this.$bvToast.toast(validationMessage, {
          title: `Invalid Search Parameters`,
          autoHideDelay: 5000,
          variant: "danger",
          solid: true,
        });
        return;
      }

      try {
        this.errorMessage = null;
        this.isLoading = true;
        this.hotels = [];
        const response = await fetch(`/hotels/find_by_ids`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(this.searchParams),
        });

        const json = await response.json();
        this.hotels = json.data;
      } catch (e) {
        console.log(e);
        this.errorMessage = "Search failed";
      }

      this.isLoading = false;
    },
    validate() {
      if (!this.searchParams.cityCode) {
        return "Please fill in City Code";
      } else if (!this.searchParams.hotelIds) {
        return "Hotel Ids must not be blank";
      } else if (this.searchParams.hotelIds) {
        const hotelIds = this.searchParams.hotelIds
        if (hotelIds.includes(" ")) {
          return "Hotel Ids must not contain spaces"
        }

        const split = hotelIds.split(",")
        for (let i = 0; i < split.length; i++) {
          const id = split[i]
          if (id.length != 8) {
            return `"${id}" needs to be 8 characters long`
          }
        }
      }
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/HotelFindByIDs.vue